<template>
    <div class="tablelist">
        <a-table
            size="middle"
            :key="this.loading.key"
            :columns="columns"
            :rowKey="record => record.id ? record.id : Math.random()"
            :dataSource="list"
            :pagination="false"
            :loading="this.loading.effects[selectType] || this.loading.effects[deleteType]"
        >
            <template slot="operation" slot-scope="text,record">
                <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                    <a :disabled="that.loading.effects[deleteType]" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <v-pageinfo v-if="pagination.total > 0" :pagination="pagination"></v-pageinfo>
    </div>
</template>

<script>
import { mapState } from "vuex";

const storeNamespace = "rc_namelist";

// const columns = []

export default {
    data() {
        return {
            that: this,
            storeNamespace,
            selectType: `${storeNamespace}/select`,
            deleteType: `${storeNamespace}/del`,
            columns: [],
            action: ""
        };
    },
    methods: {
        //删除
        onDelete(record) {
            this.$store.dispatch({
                type: this.deleteType,
                params: record
            });
        }
    },
    computed: {
        ...mapState(storeNamespace, {
            list: state => state.list,
            pagination: state => {
                return state.pagination;
            }
        })
    },
    beforeMount() {
        // let action = "";
        const { path } = this.$route;
        if (path.indexOf("/list") > -1) {
            this.action = "list";
        } else if (path.indexOf("/lishi") > -1) {
            this.action = "lishi";
        } else if (path.indexOf("/zhixing") > -1) {
            this.action = "zhixing";
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.action == "list") {
                this.columns = [
                    {
                        title: "序号",
                        width: 80,
                        align: "center",
                        customRender: (text, record, index) => ++index
                    },
                    {
                        title: "IP",
                        dataIndex: "nlip"
                    },
                    {
                        title: "是否生效",
                        dataIndex: "nlstatus",
                        width: 110,
                        customRender: text =>
                            text == "1" ? "已生效" : "未生效"
                    },
                    {
                        title: "名单类型",
                        dataIndex: "nltype",
                        customRender: text => {
                            switch (text) {
                                case "0":
                                    return "黑名单";
                                case "1":
                                    return "白名单";
                                case "2":
                                    return "接口黑名单";
                                case "3":
                                    return "接口白名单";
                                default:
                                    return "未知类型";
                            }
                        }
                    },
                    {
                        title: "servicekey",
                        dataIndex: "servicekey"
                    },
                    {
                        title: "累计次数",
                        dataIndex: "nlcount"
                    },
                    {
                        title: "截止时间",
                        dataIndex: "endtime"
                    },
                    {
                        title: "创建时间",
                        dataIndex: "createtime"
                    },
                    {
                        title: "添加说明",
                        dataIndex: "reason"
                    },
                    {
                        title: "操作",
                        width: 146,
                        scopedSlots: { customRender: "operation" }
                    }
                ];
            } else if (this.action == "lishi") {
                this.columns = [
                    {
                        title: "序号",
                        width: 80,
                        align: "center",
                        customRender: (text, record, index) => ++index
                    },
                    {
                        title: "IP",
                        dataIndex: "nlip"
                    },
                    {
                        title: "名单类型",
                        dataIndex: "nltype",
                        customRender: text => {
                            switch (text) {
                                case "0":
                                    return "黑名单";
                                case "1":
                                    return "白名单";
                                case "2":
                                    return "接口黑名单";
                                case "3":
                                    return "接口白名单";
                                default:
                                    return "未知类型";
                            }
                        }
                    },
                    {
                        title: "servicekey",
                        dataIndex: "servicekey",
                    },
                    {
                        title: "截止时间",
                        dataIndex: "endtime"
                    },
                    {
                        title: "创建时间",
                        dataIndex: "createtime"
                    },
                    {
                        title: "添加说明",
                        dataIndex: "reason"
                    }
                ];
            } else if (this.action == "zhixing") {
                this.columns = [
                    {
                        title: "序号",
                        width: 80,
                        align: "center",
                        customRender: (text, record, index) => ++index
                    },
                    {
                        title: "执行时间",
                        dataIndex: "createtime"
                    },
                    {
                        title: "名单文件所在服务器",
                        dataIndex: "fileserver"
                    },
                    {
                        title: "名单文件位置",
                        dataIndex: "filepath"
                    },
                    {
                        title: "执行结果",
                        dataIndex: "refreshresult"
                    }
                ];
            }
        });

        switch (this.action) {
            case "lishi":
                this.selectType = `${storeNamespace}/lishi`;
                break;
            case "zhixing":
                this.selectType = `${storeNamespace}/zhixing`;
                break;
            default:
                break;
        }

        this.$store.dispatch({
            type: this.selectType
        });
    }
};
</script>
<style lang="less" scoped>
</style>
